import React from 'react';
import { Link } from 'react-router-dom';
import { CheckIcon } from 'lucide-react';
import { useLanguage } from '../../contexts/LanguageContext';
import { company } from '../../data/company';
import type { TranslationKey } from '../../data/translations';
const bullets: TranslationKey[] = ['about.b1', 'about.b2', 'about.b3', 'about.b4', 'about.b5'];
export function About() {
  const {
    t
  } = useLanguage();
  return <section id="about" className="scroll-mt-24 bg-mist py-20 md:py-24" aria-labelledby="about-title" data-id="element-160" data-mp="b0sgh8fopn8b">
      <div className="mx-auto grid max-w-page items-center gap-12 px-4 sm:px-6 lg:grid-cols-2 lg:gap-16 lg:px-8" data-id="element-161" data-mp="61pexxywxz53">
        <img src={company.teamImage} alt={t('about.teamAlt')} loading="lazy" className="h-80 w-full rounded-lg object-cover lg:h-[30rem]" width={900} height={675} data-id="element-162" data-mp="jtly3cilsypc" />
        <div data-id="element-163" data-mp="3nert81d89vw1">
          <h2 id="about-title" className="font-display text-3xl font-bold leading-tight tracking-tight text-navy md:text-[2.4rem]" data-id="element-164" data-mp="3jfsmcb7xrp1y">
            {t('about.title')}
          </h2>
          <p className="mt-5 text-base leading-relaxed text-ink-muted md:text-lg" data-id="element-165" data-mp="387tiedmcuuu2">{t('about.story')}</p>

          <ul className="mt-8 space-y-3" data-id="element-166" data-mp="3cyrz3eb99uxu">
            {bullets.map(key => <li key={key} className="flex items-start gap-3 text-base text-ink-soft" data-id="element-167" data-mp="3hxv44yr8k15t">
                <CheckIcon className="mt-0.5 h-5 w-5 shrink-0 text-brand-700" aria-hidden="true" data-id="element-168" data-mp="2kae1gzo2x0mt" />
                {t(key)}
              </li>)}
          </ul>

          <Link to="/#contact" className="mt-9 inline-flex items-center rounded-md border-2 border-navy px-6 py-3 text-base font-bold text-navy transition-colors duration-200 ease-smooth hover:bg-navy hover:text-white" data-id="element-169" data-mp="2p9pga34vxw1r">
            {t('about.cta')}
          </Link>
        </div>
      </div>
    </section>;
}